import React, { useState, useEffect } from "react";
import BASE_URL from "../../config";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);

      if (element) {
        setTimeout(() => {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }, 100);
      }
    }
  }, [location]);
  /* ================= HERO SLIDER ================= */
  const [slides, setSlides] = useState([]);
  const [current, setCurrent] = useState(0);
  const navigate = useNavigate();
  // Fetch hero images
  useEffect(() => {
    fetch(`${BASE_URL}/api/gethero.php`)
      .then((res) => res.json())
      .then((data) => {
        // console.log("Hero Data:", data);
        setSlides(Array.isArray(data) ? data : []);
      })
      .catch((err) => console.error(err));
  }, []);

  // Auto slide (ONLY ONE interval)
  useEffect(() => {
    if (slides.length === 0) return;

    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [slides]);

  // Reset index when slides change
  useEffect(() => {
    setCurrent(0);
  }, [slides]);

  /* ================= HOLIDAYS ================= */
  const [holidays, setHolidays] = useState([]);

  useEffect(() => {
    const fetchHolidays = () => {
      fetch(`${BASE_URL}/api/getHolidays.php?t=${Date.now()}`)
        .then((res) => res.json())
        .then((data) => setHolidays(Array.isArray(data) ? data : []))
        .catch((err) => console.error(err));
    };

    fetchHolidays();
    const interval = setInterval(fetchHolidays, 5000);

    return () => clearInterval(interval);
  }, []);

  /* ================= NEWS ================= */
  const [newsList, setNewsList] = useState([]);

  useEffect(() => {
    const fetchNews = () => {
      fetch(`${BASE_URL}/api/getNews.php?t=${Date.now()}`)
        .then((res) => res.json())
        .then((data) => setNewsList(Array.isArray(data) ? data : []))
        .catch((err) => console.error(err));
    };

    fetchNews();
    const interval = setInterval(fetchNews, 5000);

    return () => clearInterval(interval);
  }, []);

  /* ================= UI STATE ================= */
  const [activePlan, setActivePlan] = useState("bachat");

  /* ================= RETURN ================= */
  return (
    <>
      {/* HERO */}
      {/* HERO SECTION */}
      <section className="hero-section">
        <div className="hero-content">
          {/* LEFT CONTENT */}
          <div className="hero-left">
            <span className="hero-badge">મહિલા ક્રેડિટ કો-ઓપરેટીવ સોસાયટી</span>

            <h1 className="hero-title">
              શ્રી ગૃહલક્ષ્મી અર્બન કો.ઓપ. થ્રીફ્ટ, ક્રેડિટ એન્ડ કન્ઝયુમર
              સોસાયટી લિ. માં તમારું સ્વાગત છે
            </h1>

            <p className="hero-description">
              સમગ્ર સુરત શહેર ના સભાસદ બહેનો ને જણાવતા અમો આનંદ અનુભવીએ છીએ કે,
              આ વિસ્તાર ની એકમાત્ર ૧૦,૦૦૦ સભાસદો ધરાવતી મહિલા ક્રેડિટ સોસાયટી
              માં સભાસદ થઇ નીચે મુજબ ની યોજનાઓ ના લાભ મેળવો..
            </p>

            <div className="hero-buttons">
              <button
                className="primary-btn"
                onClick={() => navigate("/about")}
              >
                વધુ જાણો
              </button>

              <button
                className="secondary-btn"
                onClick={() => navigate("/join")}
              >
                સંપર્ક કરો
              </button>
            </div>

            {/* STATS */}
            <div className="hero-stats">
              <div className="stat-box">
                <h3>૧૦,૦૦૦+</h3>
                <p>સભાસદો</p>
              </div>

              <div className="stat-box">
                <h3>૨૦+</h3>
                <p>વર્ષનો વિશ્વાસ</p>
              </div>

              <div className="stat-box">
                <h3>૧૦૦%</h3>
                <p>વિશ્વસનીય સેવા</p>
              </div>
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="hero-right">
            {slides.length > 0 && slides[current] && (
              <img
                src={`${BASE_URL}/uploads/${slides[current].image}`}
                alt="hero"
                className="hero-image"
              />
            )}

            {/* Floating Card */}
          </div>
        </div>
      </section>
      {/* WELCOME */}

      {/* NEWS */}
      <div className="news-section">
        <h2>તાજી માહિતી</h2>

        <div className="news-container">
          {newsList.length === 0 ? (
            <p>કોઈ માહિતી નથી</p>
          ) : (
            newsList.map((news) => (
              <div className="news-card" key={news.id}>
                <span className="news-date">{news.date}</span>
                <h4>{news.title}</h4>
                <p>{news.description}</p>
              </div>
            ))
          )}
        </div>
      </div>
      <div className="head">
        <h2>સોસાયટી માં શેર સભાસદ થવા માટે ખાસ ઓફર </h2>
      </div>

      <div className="membership-title">
        <h2>શેર સભાસદ થવા માટે</h2>{" "}
      </div>
      <div className="membership-section">
        {/* ================================= */}
        {/* FIRST : VIMA SATHE */}
        {/* ================================= */}

        {/* ================================= */}
        {/* SECOND : VIMA VAGAR */}
        {/* ================================= */}

        <div className="membership-left">
          <div className="membership-badge">PREMIUM MEMBERSHIP</div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h3 style={{ alignItems: "center" }}>વીમા સાથે</h3>
            <h4>વીમા રકમ : ૩,૦૦,૦૦૦/-</h4>
          </div>

          <p>વીમા યોજના સાથે સભ્યપદ મેળવી વધુ સુરક્ષા અને વિશેષ લાભ મેળવો.</p>
          <div className="membership-row">
            <div className="membership-right">
              <div className="member-card">
                <h4>સભાસદ ફી</h4>

                <table className="member-table">
                  <tbody>
                    <tr>
                      <td>શેર</td>
                      <td>૫૦૦/-</td>
                    </tr>
                    <tr>
                      <td>ફરિજયાત બચત</td>
                      <td>૩૦૦૦/-</td>
                    </tr>
                    <tr>
                      <td>બિલ્ડીંગ ફંડ</td>
                      <td>૫૦૦/-</td>
                    </tr>

                    <tr>
                      <td>વહીવટી ફાળો</td>
                      <td>૩૦૦/-</td>
                    </tr>

                    <tr>
                      <td>વીમા યોજના એન્ટ્રી ફ્રી</td>
                      <td>૮૦૦૦/-</td>
                    </tr>

                    <tr>
                      <td>સ્ટેશનરી ચાર્જ</td>
                      <td>૧૫૦/-</td>
                    </tr>

                    <tr>
                      <td>પ્રવેશ ફી</td>
                      <td>૧૦૦/-</td>
                    </tr>

                    <tr className="total-row">
                      <td>કુલ</td>
                      <td>૧૨૫૫૦/-</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="member-card">
                <div className="row">
                  <h4>જરૂરી ડોક્યુમેન્ટસ</h4>
                  <div className="col-md-5">
                    <ul className="member-list">
                      <li>૪ ફોટા</li>
                      <li>આધાર કાર્ડ</li>
                      <li>પાનકાર્ડ</li>
                      <li>ચૂંટણી કાર્ડ</li>

                      <li>બેંક પાસબુક</li>
                    </ul>
                  </div>

                  <div className="col-md-7">
                    <ul className="member-list">
                      <li>વેરાબીલ રસીદ</li>
                      <li>લાઈટબીલ (ભાડુઆત હોય તો)</li>

                      <li>સ્કૂલ એલ. સી. / દાખલો</li>
                    </ul>
                  </div>
                </div>

                <div className="row">
                  <h5>:: વારસદાર ::</h5>
                  <div className="col-md-5">
                    <ul className="member-list">
                      <li>૨ ફોટો</li>
                      <li>આધારકાર્ડ</li>
                      <li>પાનકાર્ડ</li>
                    </ul>
                  </div>
                  <div className="col-md-7">
                    <ul className="member-list">
                      <li>ચૂંટણીકાર્ડ</li>
                      <li>બેંક પાસબુક ની ઝેરોક્ષ</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="membership-left">
          <div className="membership-badge">BASIC MEMBERSHIP</div>

          <h3>વીમા વગર</h3>

          <p>
            સામાન્ય સભ્યપદ યોજના જેમાં મૂળભૂત લાભ અને શેર સભ્યપદ સુવિધા મળે છે.
          </p>
          <div className="membership-row">
            <div className="membership-right">
              <div className="member-card">
                <h4>સભાસદ ફી</h4>

                <table className="member-table">
                  <tbody>
                    <tr>
                      <td>શેર</td>
                      <td>૫૦૦/-</td>
                    </tr>
                    <tr>
                      <td>ફરિજયાત બચત</td>
                      <td>૧૦૦૦/-</td>
                    </tr>

                    <tr>
                      <td>બિલ્ડીંગ ફંડ</td>
                      <td>૫૦૦/-</td>
                    </tr>

                    <tr>
                      <td>વહીવટી ફાળો</td>
                      <td>૩૦૦/-</td>
                    </tr>

                    <tr>
                      <td>સ્ટેશનરી ચાર્જ</td>
                      <td>૧૫૦/-</td>
                    </tr>

                    <tr>
                      <td>પ્રવેશ ફી</td>
                      <td>૧૦૦/-</td>
                    </tr>
                    <tr className="total-row">
                      <td>કુલ</td>
                      <td>૨૫૫૦/-</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="member-card">
                <h4>જરૂરી ડોક્યુમેન્ટસ</h4>

                <ul className="member-list">
                  <li>2 ફોટા</li>
                  <li>આધાર કાર્ડ</li>
                  <li>પાનકાર્ડ</li>
                  <li>ચૂંટણી કાર્ડ</li>
                  <li>વેરાબીલ રસીદ</li>
                  <li>લાઈટબીલ (ભાડુઆત હોય તો )</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="gl-benefits-section">
        {/* Top Oval */}
        <div className="gl-benefits-badge">
          <p>
            ૧૮ વર્ષ થી ૫૫ વર્ષ
            <br />
            સુધીનાં કોઈપણ
            <br />
            વ્યક્તિ સભાસદ બની શકે છે.
          </p>
        </div>

        {/* Bottom Left Circle */}
        <div className="gl-benefits-circle">
          <img
            src="images/benifits.jpg"
            alt="Saving Family"
            className="circle-img"
          />
        </div>

        {/* Right Content */}
        <div className="gl-benefits-content">
          <h2 className="gl-benefits-title">
            ગૃહલક્ષ્મી અર્બનમાં સભાસદ બનવાના લાભ
          </h2>

          <div className="gl-benefits-list">
            <div className="gl-benefits-item">લોનની ઝડપી અને સરળ સુવિધા</div>

            <div className="gl-benefits-item">
              લોન નિયમિત ભરનારને નિયમોનુસાર વ્યાજ રિબેટ આપવામાં આવશે.
            </div>

            <div className="gl-benefits-item">
              દર વર્ષે સભાસદ બહેનોનાં બાળકોને ઇનામ વિતરણ
            </div>

            <div className="gl-benefits-item">
              જુના તથા નવા સભાસદે દર વર્ષે તા. ૧ એપ્રિલ થી ફરજીયાત બચત ના
              ₹૧૦૦૦/- ફરજીયાત ભરી પોતાની ફ્રી ગીફ્ટ તથા ફુલસ્કેપ ચોપડા મેળવી
              લેવા.
            </div>
            <div className="gl-benefits-item">
              ચાર ના ગ્રુપ માં સભાસદ બની તુરંત જ ₹૫૦,૦૦૦ રોકડ ધિરાણ મેળવો.
            </div>
          </div>
        </div>
      </section>

      <div className="trust-section">
        <div className="trust-header">
          <span className="trust-tag">WHY CHOOSE US</span>

          <h2>અમને કેમ પસંદ કરશો?</h2>

          <p>
            વિશ્વાસ, સુરક્ષા અને પારદર્શક સેવાઓ સાથે મહિલાઓ માટે ખાસ બનાવેલ
            સહકારી સંસ્થા.
          </p>
        </div>

        <div className="modern-container">
          <div className="modern-card">
            <div className="icon">
              <i className="bi bi-check-circle"></i>
            </div>
            <h4>પારદર્શક વહીવટ</h4>
            <p>સંપૂર્ણ પારદર્શક અને કાયદેસરની કામગીરી.</p>
          </div>

          <div className="modern-card">
            <div className="icon">
              <i className="bi bi-people"></i>
            </div>
            <h4>મહિલા સંચાલિત</h4>
            <p>મહિલાઓ દ્વારા, મહિલાઓ માટે અને મહિલાઓનું સંગઠન.</p>
          </div>

          <div className="modern-card">
            <div className="icon">
              <i className="bi bi-lightning"></i>
            </div>
            <h4>આકર્ષક વ્યાજ દર</h4>
            <p>થાપણો પર વધુ વ્યાજ અને લોન પર વ્યાજબી દર.</p>
          </div>

          <div className="modern-card">
            <div className="icon">
              <i className="bi bi-shield-lock"></i>
            </div>
            <h4>સરળ પ્રક્રિયા</h4>
            <p>લોન અને ખાતા ખોલાવવા માટેની ન્યૂનતમ દસ્તાવેજી પ્રક્રિયા.</p>
          </div>
        </div>
      </div>

      {/* SERVICES */}
      {/* DETAIL SECTION */}

      <div className="plan-detail">
        <div className="membership-title">
          <h2 style={{ marginBottom: "40px" }}>અમારી સેવાઓ</h2>
        </div>

        <div className="zigzag-wrapper">
          {/* ===================== BACHAT ===================== */}
          <div className="zigzag-row1" id="bachat">
            <div className="zigzag-tag">Saving Plan</div>
            <div className="poster-title1">
              {" "}
              ❖ વિવિધ પ્રકારની માસિક તેમજ દૈનિક બચત યોજના ❖
            </div>
            <div className="bachat-banner" id="bachat">
              <div className="banner-overlay"></div>

              <div className="banner-left">
                <h1>
                  સાથે મળીને બનાવીએ
                  <br />
                  <span>સશક્ત સમાજ</span>
                </h1>

                <p>જરૂરિયાતમંદ પરિવારોને આર્થિક સહાય</p>

                <div className="feature-boxes">
                  <div className="feature-item blue">
                    <i className="bi bi-heart-fill"></i>
                    <span>અનુકૂળ રકમ ની શરૂઆત</span>
                  </div>

                  <div className="feature-item green">
                    <i className="bi bi-people-fill"></i>
                    <span>માસિક રોકાણ , મહત્તમ લાભ</span>
                  </div>

                  <div className="feature-item orange">
                    <i className="bi bi-award-fill"></i>
                    <span>સુરક્ષિત રોકાણ નિશ્ચિત જીવન</span>
                  </div>
                </div>

                <div className="highlight-box">
                  <div className="highlight-icon">
                    <i className="bi bi-currency-rupee"></i>
                  </div>

                  <div className="highlight-content">
                    ફક્ત ₹૫૦૦/- કે તેના ગુણાંકમાં ૧ વર્ષની મુદત માટે ખાતું
                    ખોલાવી શકાય છે.
                  </div>
                </div>
              </div>
            </div>
            <div className="saving-plan-section">
              <div className="saving-card purple1">
                <div className="saving-icon">
                  <i className="bi bi-wallet2"></i>
                </div>

                <p>₹૫૦૦/- નાં ૧૨ માસ</p>
                <h3>મુજબ રકમ ₹૬૩૦૦/-</h3>
              </div>

              <div className="saving-card green1">
                <div className="saving-icon">
                  <i className="bi bi-wallet2"></i>
                </div>

                <p>₹૧૦૦૦/- નાં ૧૨ માસ</p>
                <h3>મુજબ રકમ ₹૧૨૬૦૦/-</h3>
              </div>

              <div className="saving-card pink">
                <div className="saving-icon">
                  <i className="bi bi-wallet2"></i>
                </div>

                <p>₹૨૦૦૦/- નાં ૧૨ માસ</p>
                <h3>મુજબ રકમ ₹૨૫૨૦૦/-</h3>
              </div>

              <div className="saving-card orange">
                <div className="saving-icon">
                  <i className="bi bi-wallet2"></i>
                </div>

                <p>₹૫૦૦૦/- નાં ૧૨ માસ</p>
                <h3>મુજબ રકમ ₹૬૩૦૦૦/-</h3>
              </div>
            </div>

            <div className="gift-banner">
              <i className="bi bi-shield-check"></i>

              <span>
                દરેક ખાતા પર એક આકર્ષક <strong>ગિફ્ટ</strong> તો ખરી જ !
              </span>

              <i className="bi bi-gift-fill gift-icon"></i>
            </div>
            <div className="saving-section-bg">
              <div className="saving-header">
                <div className="saving-title">દૈનિક બચત યોજના</div>

                <h3 className="saving-subtitle">
                  બચત એટલે ભવિષ્યના પૈસાની સાચવણી નહીં, પણ તમારા સ્વપ્નોનું
                  રોકાણ છે.
                </h3>

                <div className="saving-highlight">
                  <i className="bi bi-shield-fill-check"></i>
                  <span style={{ background: "transparent" }}>
                    સંસ્થા ના કર્મચારી રૂબરૂ દૈનિક બચત લેવા તમારા ઘરે અથવા દુકાન
                    પર આવશે.
                  </span>
                </div>
              </div>

              <div className="saving-benefits">
                <div className="benefit-item">
                  <i className="bi bi-shield-check"></i>
                  <span>સુરક્ષિત રોકાણ</span>
                </div>

                <div className="benefit-item">
                  <i className="bi bi-graph-up-arrow"></i>
                  <span>આકર્ષક વ્યાજદર</span>
                </div>

                <div className="benefit-item">
                  <i className="bi bi-currency-exchange"></i>
                  <span>નિયમિત અને સરળ બચત</span>
                </div>

                <div className="benefit-item">
                  <i className="bi bi-people-fill"></i>
                  <span>સુરક્ષિત ભવિષ્યની ખાતરી</span>
                </div>
              </div>
            </div>
          </div>

          {/* ===================== LOAN ===================== */}

          <div className="zigzag-row loan-poster" id="fd">
            <div className="row">
              <div className="col-md-6">
                <div className="zigzag-image12">
                  <img src="/images/fd1.png" alt="" />
                </div>
              </div>
              <div className="col-md-6 col">
                <div className="mar">
                  <div className="zigzag-tag">Fixed Deposit</div>
                  <div className="poster-title">❖ ફિક્સ ડિપોઝિટ યોજના ❖</div>
                  <div className="deposit-plans-wrap">
                    <div className="row g-4">
                      <div className="col-md-6">
                        <div className="deposit-card plan-one">
                          <div className="rate-badge">૧ વર્ષ માટે</div>
                          <h2>૭.૫%</h2>
                          <p>વાર્ષિક વ્યાજ દર</p>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="deposit-card plan-two">
                          <div className="rate-badge">૨ વર્ષ માટે</div>
                          <h2>૮.૫%</h2>
                          <p>વાર્ષિક વ્યાજ દર</p>
                        </div>
                      </div>
                    </div>

                    <div className="special-offer gift-card">
                      <div className="offer-icon">
                        <i className="bi bi-gift-fill"></i>
                      </div>

                      <div>
                        <h3>૩ વર્ષ માટે ૯.૫%</h3>
                        <p>₹૨૫,૦૦૦/- કે તેથી વધુ ની રકમ પર આકર્ષક ફ્રી ગિફ્ટ</p>
                      </div>
                    </div>

                    <div className="special-offer double-money">
                      <div className="offer-icon">
                        <i className="bi bi-coin"></i>
                      </div>

                      <div>
                        <h3>8 વર્ષે બમણાં</h3>
                        <p>₹૫,૦૦૦/- કે તેથી વધુ ની રકમ પર આકર્ષક ફ્રી ગિફ્ટ</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* ===================== INSURANCE ===================== */}

          <div className="zigzag-row loan-poster" id="insurance">
            <div className="row">
              <div className="col-md-8">
                {" "}
                <div>
                  <div className="zigzag-tag">Insurance Plan</div>
                  <div className="poster-title">❖ વીમા યોજના ❖</div>

                  <h5
                    style={{
                      fontWeight: "600",
                      fontSize: "20px",
                      color: "#e24118",
                    }}
                  >
                    તા. ૦૧/૦૪/૨૦૨૩ થી શ્રી ગૃહલક્ષ્મી સુરક્ષા કવચ વીમા યોજના
                    ₹૨,૦૦,૦૦૦/- સંપૂર્ણપણે ચાલુ છે.
                  </h5>
                  <h5
                    style={{
                      fontWeight: "600",
                      fontSize: "20px",
                      color: "#589167",
                    }}
                  >
                    વીમાયોજનામાં જોડનાર દરેક સભાસદને ફ્રી ગિફ્ટ નો લાભ મળશે.
                  </h5>
                  <ul className="zigzag-list">
                    <li>
                      ઘણા સમયથી સભાસદ ભાઈઓ તથા બહેનોના સતત આગ્રહ અને માંગણીને
                      ધ્યાનમાં રાખીને તા: ૦૧/૦૯/૨૦૨૫ થી “શ્રી ગૃહલક્ષ્મી સુરક્ષા
                      કવચ” વીમા યોજના ₹૩,૦૦,૦૦૦/- (ત્રણ લાખ) શરુ કરવા જઈ રહ્યા
                      છીએ, તેના અનુસંધાને તા: ૦૧/૦૯/૨૦૨૫ થી કુલ ૧૦૦૦ વીમા
                      યોજનાના સભાસદ થયેથી યોજના શરુ થશે.
                    </li>
                    <li>
                      તા: ૦૧/૦૪/૨૦૨૩ થી “ શ્રી ગૃહલક્ષ્મી સુરક્ષા કવચ” વીમા
                      યોજના ₹૨,૦૦,૦૦૦/- (બે લાખ) સંપૂર્ણપણે ચાલુ છે.
                    </li>

                    <li>
                      ₹૩,૦૦,૦૦૦/- ની વીમા યોજનાનો અમલ શરૂ ન થાય ત્યાં સુધી
                      ₹૨,૦૦,૦૦૦/- નો વીમો તો મળવાપાત્ર છે જ.
                    </li>

                    <li>
                      ₹૨,૦૦,૦૦૦/- (બે લાખ) વીમાયોજનામાં જે ચાલુ સભાસદો છે તેમણે
                      ફક્ત ₹૩૬૫૦/- (નોન રિફંડેબલ) ભર્યે થી નવી યોજના ₹૩,૦૦,૦૦૦/-
                      માં જોડાઈ ને વીમા નો લાભ મળવા પાત્ર બનશે.
                    </li>

                    <li>
                      ૧૮ થી ૫૫ વર્ષ સુધીનાં સભાસદ વીમા યોજના માં જોડાય શકશે,
                      તેમજ જ્યાં સુધી સભાસદ તરીકે ચાલુ રહેશે ત્યાં સુધી વીમો
                      મળવાપાત્ર છે.
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-4">
                {" "}
                <div
                  className="zigzag-image1 col4"
                  style={{ marginTop: "60px", marginBottom: "10px" }}
                >
                  <img src="/images/vima.png" alt="" />
                </div>
              </div>
              <div className="col-md-12">
                <ul className="zigzag-list">
                  <li>
                    સદર મંડળીમાં વીમા યોજનામાં જોડાયેલા સભાસદે પ્રથમવાર વીમો
                    કરાવતી વખતે ફક્ત એક વખત ₹૮૬૫૦/- વીમા યોજના ફી ભરવાની રહેશે.
                    જે કોઈપણ સંજોગોમાં પરત મળવાપાત્ર નથી
                  </li>

                  <li>
                    વીમાદાર સભાસદ ના ખાતા માંથી સભાસદ દીઠ કોઈપણ વ્યક્તિ નું
                    મૃત્યુ થાય તે સમયે જે રકમ મંડળી દ્વારા નક્કી કરવામાં આવે તે
                    તેના ફરજીયાત રકમ ના ખાતામાંથી ઉધારવા માં આવશે.
                  </li>

                  <li>
                    સભાસદ થયા બાદ તરત જ ફરજીયાત બચતના ખાતા માંથી વીમા સહાય માટે
                    જે રકમ કપાયેલી હોય તે દર વર્ષે એપ્રિલ માં ફરજીયાત બચતની સાથે
                    જ ફરજીયાત જમા કરાવવાની રહેશે.
                  </li>

                  <li>
                    જે વીમાદાર સભાસદની ફરજીયાત બચત+વીમાપેટે કપાયેલી રકમ જમા
                    કરવાની બાકી હશે તો તે વીમો માન્ય ગણાશે નહી.
                  </li>

                  <li>
                    કોઈપણ વીમેદાર સભાસદ નું મૃત્યુ થશે તો સભાસદ ની ફરજીયાત બચત
                    બાકી હોય તો તે ભરેલી હોવી જોઈએ.
                  </li>

                  <li>
                    કોઈપણ લોન લેનાર સભાસદમાં જામીન થયેલા હશો, તે બાબત ક્લિયર ના
                    થાય ત્યાં સુધી પાકતી વિમાની રકમ અટકાવવામાં આવશે.
                  </li>

                  <li>
                    વીમાદાર વ્યક્તિ જે લોન લેનાર સભાસદમાં જામીન થયેલા હશે, જે
                    રેગ્યુલર સભાસદ હશે તો યોગ્ય બાબત વિચારી યોગ્ય કરવામાં આવશે.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* ================= LOAN FACILITY ================= */}

          <div className="loan-section" id="loan">
            <div className="poster-title">❖ લોન સુવિધા ❖</div>

            {/* PERSONAL LOAN */}
            <div className="loan-row">
              <div className="loan-left">
                <div className="loan-icon blue">
                  <i className="bi bi-person-fill"></i>
                </div>

                <div>
                  <h3>Personal Loan</h3>
                  <h5>(જાત જામીનગીરી લોન)</h5>

                  <span className="amount-badge">₹૨,૦૦,૦૦૦/- સુધી લોન</span>
                </div>
              </div>

              <div className="loan-features">
                <div className="loan-feature blue1">
                  <i className="bi bi-currency-rupee"></i>
                  <p>ઝડપી મંજૂરી</p>
                </div>

                <div className="loan-feature blue1">
                  <i className="bi bi-clock-fill"></i>
                  <p>ઓછી કાર્યવાહી</p>
                </div>

                <div className="loan-feature blue1">
                  <i className="bi bi-shield-check"></i>
                  <p>જાત જામીનગીરી લોન</p>
                </div>
              </div>

              <div className="loan-rate blue-rate blue1">
                <span>વ્યાજ દર</span>
                <h2 style={{ marginBottom: "5px" }}>૧૮%</h2>
              </div>

              <div className="loan-image">
                <img src="images/personalloan1.png" alt="" />
              </div>
            </div>

            {/* GOLD LOAN */}

            <div className="loan-row">
              <div className="loan-left">
                <div className="loan-icon gold">
                  <i className="bi bi-coin"></i>
                </div>

                <div>
                  <h3>Gold Loan</h3>
                  <h5>(ગોલ્ડ લોન)</h5>
                </div>
              </div>

              <div className="loan-features">
                <div className="loan-feature gold1">
                  <i className="bi bi-cash-stack"></i>
                  <p>સોનાના આધાર પર લોન</p>
                </div>

                <div className="loan-feature gold1">
                  <i className="bi bi-percent"></i>
                  <p>આકર્ષક વ્યાજ દર</p>
                </div>

                <div className="loan-feature gold1">
                  <i className="bi bi-shield-check"></i>
                  <p>સુરક્ષિત અને વિશ્વસનીય</p>
                </div>
              </div>

              <div className="loan-rate gold-rate">
                <span>વ્યાજ દર</span>
                <h2 style={{ marginBottom: "5px" }}>૧૦%</h2>
              </div>

              <div className="loan-image">
                <img src="images/gold.png" alt="" />
              </div>
            </div>

            {/* PROPERTY LOAN */}

            <div className="loan-row">
              <div className="loan-left">
                <div className="loan-icon green">
                  <i className="bi bi-house-door-fill"></i>
                </div>

                <div>
                  <h3>Property Loan</h3>
                  <h5>(મિલકતના તારણ પર લોન)</h5>

                  <span className="amount-badge">
                    ₹૩૦,૦૦,૦૦૦/- (ત્રીસ લાખ) સુધી
                  </span>
                </div>
              </div>

              <div className="loan-features">
                <div className="loan-feature green1">
                  <i className="bi bi-buildings-fill"></i>
                  <p>વધુ રકમની લોન</p>
                </div>

                <div className="loan-feature green1">
                  <i className="bi bi-percent"></i>
                  <p>આકર્ષક વ્યાજ દર</p>
                </div>

                <div className="loan-feature green1">
                  <i className="bi bi-check-circle-fill"></i>

                  <p>હપ્તા ની સંખ્યા</p>
                  <h2
                    style={{
                      fontSize: "20px",
                      marginBottom: "5px",
                      fontWeight: "bold",
                    }}
                  >
                    ૧૨૦
                  </h2>
                </div>
              </div>

              <div className="loan-rate property-rate">
                <span>વ્યાજ દર</span>
                <h2 style={{ marginBottom: "5px" }}>૧૮%</h2>
              </div>

              <div className="loan-image">
                <img src="images/homeloan.jpg" alt="" />
              </div>
            </div>

            {/* CONSUMER LOAN */}

            <div className="loan-row">
              <div className="loan-left">
                <div className="loan-icon purple">
                  <i className="bi bi-cart-fill"></i>
                </div>

                <div>
                  <h3>Consumer Loan</h3>
                  <h5>(અનાજ ધિરાણ)</h5>

                  <span className="amount-badge ">
                    ₹૨૫,૦૦૦/- (પચ્ચીસ હજાર ) સુધી
                  </span>
                </div>
              </div>

              <div className="loan-features">
                <div className="loan-feature purple1">
                  {/* <p>દર વર્ષે 12 માસનું શોપિંગ</p> */}
                  {/* <i className="bi bi-calendar-check-fill"></i> */}
                  <p>
                    {" "}
                    દર વર્ષે સભાસદો માટે ૧૨ માસનું અનાજ, કરિયાણું વગેરે એક સાથે
                    ભરવા માટે ₹૨૫,૦૦૦/- સુધીની તુરંત જ લોન
                  </p>
                </div>

                <div className="loan-feature purple1">
                  <i className="bi bi-percent"></i>
                  <p>આકર્ષક વ્યાજ દર</p>
                </div>

                <div className="loan-feature purple1">
                  <i className="bi bi-check-circle-fill"></i>

                  <p>હપ્તા ની સંખ્યા</p>
                  <h2
                    style={{
                      fontSize: "20px",
                      marginBottom: "5px",
                      fontWeight: "bold",
                    }}
                  >
                    ૧૦
                  </h2>
                </div>
              </div>

              <div className="loan-rate consumer-rate">
                {/* <div className="consumer-special">
                  દર વર્ષે સભાસદો માટે 12 માસનું અનાજ, કરિયાણું વગેરે એક સાથે
                  ભરવા માટે 25,000/- સુધીની તુરંત જ લોન
                </div> */}
                <span>વ્યાજ દર</span>
                <h2 style={{ marginBottom: "5px" }}>૧૦%</h2>
              </div>

              <div className="loan-image">
                <img src="images/consumerloan.png" alt="" />
              </div>
            </div>

            {/* VEHICLE LOAN */}

            <div className="loan-row">
              <div className="loan-left">
                <div className="loan-icon cyan">
                  <i className="bi bi-car-front-fill"></i>
                </div>

                <div>
                  <h3>Vehicle loan</h3>
                  <h5>(સાધન ધિરાણ)</h5>

                  <span className="amount-badge">
                    ₹૫,૦૦,૦૦૦/- (પાંચ લાખ) સુધી
                  </span>
                </div>
              </div>

              <div className="loan-features">
                <div className="loan-feature cyan1">
                  <i className="bi bi-car-front"></i>
                  <p>નવી અને જૂની બંને વાહન માટે</p>
                </div>

                <div className="loan-feature cyan1">
                  <i className="bi bi-percent"></i>
                  <p>ઓછી ડાઉન પેમેન્ટ</p>
                </div>

                <div className="loan-feature cyan1">
                  <i className="bi bi-check-circle-fill"></i>

                  <p>હપ્તા ની સંખ્યા</p>
                  <h2
                    style={{
                      fontSize: "20px",
                      marginBottom: "5px",
                      fontWeight: "bold",
                    }}
                  >
                    ૧૨૦
                  </h2>
                </div>
              </div>

              <div className="loan-rate vehicle-rate">
                <span>વ્યાજ દર</span>
                <h2 style={{ marginBottom: "5px" }}>૧૮%</h2>
              </div>

              <div className="loan-image">
                <img src="images/vehicleloan.webp" alt="" />
              </div>
            </div>

            <div className="loan-footer">
              સુરક્ષિત ♦ વિશ્વસનીય ♦ ઝડપી મંજૂરી ♦ ગ્રાહક પ્રથમ
            </div>
          </div>
        </div>
      </div>

      <div className="trust-section">
        <div className="trust-header12">
          <h2
            style={{
              fontSize: "40px",
              color: "#ffeb3b",
              fontWeight: "bold",
              marginBottom: "30px",
            }}
          >
            તો પછી રાહ શેની જુઓ છો , આવો અને સોસાયટી નાં શેર સભાસદ બનો.
          </h2>

          <p style={{ color: "#f5f8fc", fontWeight: "bold", fontSize: "18px" }}>
            દરેક યોજનાની વિસ્તૃત માહિતી તેમજ સોસાયટીમાં શેર સભાસદ થવા માટે બહેનો
            ઓફિસે કાર્યાલયમાં મેનેજરશ્રી ને ઓફિસ સમય દરમિયાન રૂબરૂ મળો.
          </p>

          <p style={{ color: "#f5f8fc", fontWeight: "bold", fontSize: "18px" }}>
            કામકાજ નો સમય: સોમ થી શનિ :- 10:00 થી 5:00
          </p>
          <p style={{ color: "#f5f8fc", fontWeight: "bold", fontSize: "18px" }}>
            બીજા તથા ચોથા શનિવારે રજા રહેશે.
          </p>
          <button
            style={{
              fontSize: "18px",
              background: "#ffeb3b",
              color: "#0a2c42",
              width: "200px",
            }}
            onClick={() => navigate("/join")}
          >
            સંપર્ક કરો
          </button>
        </div>

        <div className="modern-container"></div>
      </div>

      {/* HOLIDAYS */}
      <div className="holiday-section">
        <div className="holiday-top">
          <span className="holiday-tag">BANK HOLIDAYS</span>

          <h2>બેંક રજાઓ</h2>

          <p>
            સોસાયટી તથા બેંક ની મહત્વપૂર્ણ રજાઓ ની માહિતી અહીં આપવામાં આવેલ છે.
          </p>
        </div>

        <table className="holiday-table">
          <thead>
            <tr>
              <th>ક્રમ</th>
              <th>તારીખ</th>
              <th>રજાનું નામ</th>
            </tr>
          </thead>

          <tbody>
            {holidays.length === 0 ? (
              <tr>
                <td colSpan="3">કોઈ રજા નથી</td>
              </tr>
            ) : (
              holidays.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>{item.date}</td>
                  <td>{item.name}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}
